import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Chat/Login";
import Chat from "./Chat/Chat";

function App()
{
  return(
    <div>
      <BrowserRouter>
        <Routes>
          <Route path = "/" element = { <Login /> } />
          <Route path = "/chat" element = { <Chat group_id = "1" /> } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;